import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Inject, Input, Output, TemplateRef, ViewChild, } from '@angular/core';
import { TemplateUuids } from '@mhe/ngx-shared/utils';
import { Subject, asyncScheduler, fromEvent } from 'rxjs';
import { subscribeOn, takeUntil, tap } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/cdk/overlay";
import * as i2 from "@angular/cdk/a11y";
import * as i3 from "@angular/common";
import * as i4 from "@angular/cdk/portal";
import * as i5 from "@mhe/ngx-shared/tooltip";
import * as i6 from "@mhe/ngx-shared/translate";
const _c0 = ["cancelButton"];
const _c1 = ["confirmButton"];
const _c2 = ["modalTemplatePortal"];
function ModalComponent_ng_template_0_div_3_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function ModalComponent_ng_template_0_div_3_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r9.onClose()); });
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "mheTranslate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("btn-close-white", ctx_r8.btnCloseWhite);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 3, i0.ɵɵpipeBind1(2, 5, "ngx-shared-close-dialog")));
} }
function ModalComponent_ng_template_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "h2", 12);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ModalComponent_ng_template_0_div_3_button_3_Template, 3, 7, "button", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", ctx_r2.templateUUIDs.get("dialog-heading"));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.titleText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.disableClose);
} }
function ModalComponent_ng_template_0_div_4_ng_template_1_Template(rf, ctx) { }
function ModalComponent_ng_template_0_div_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r13.descriptionText);
} }
function ModalComponent_ng_template_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, ModalComponent_ng_template_0_div_4_ng_template_1_Template, 0, 0, "ng-template", 16);
    i0.ɵɵtemplate(2, ModalComponent_ng_template_0_div_4_ng_template_2_Template, 2, 1, "ng-template", null, 17, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r12 = i0.ɵɵreference(3);
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("id", ctx_r3.templateUUIDs.get("dialog-description"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.descriptionTemplateRef || _r12);
} }
function ModalComponent_ng_template_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p", 18);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r4.contentText);
} }
function ModalComponent_ng_template_0_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0);
} }
function ModalComponent_ng_template_0_div_9_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 23, 24);
    i0.ɵɵlistener("click", function ModalComponent_ng_template_0_div_9_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r18.onCancel()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("disabled", ctx_r14.disableCancel);
    i0.ɵɵattribute("cdkFocusInitial", ctx_r14.focusOnConfirm || ctx_r14.showTitlebar ? null : "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r14.cancelButtonText, " ");
} }
function ModalComponent_ng_template_0_div_9_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25, 26);
    i0.ɵɵlistener("click", function ModalComponent_ng_template_0_div_9_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r21.onConfirm()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("disabled", ctx_r15.disableConfirm);
    i0.ɵɵattribute("cdkFocusInitial", ctx_r15.focusOnConfirm && !ctx_r15.showTitlebar ? "" : null);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r15.confirmButtonText, " ");
} }
function ModalComponent_ng_template_0_div_9_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r16.footerMessage);
} }
function ModalComponent_ng_template_0_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, ModalComponent_ng_template_0_div_9_button_1_Template, 3, 3, "button", 20);
    i0.ɵɵtemplate(2, ModalComponent_ng_template_0_div_9_button_2_Template, 3, 3, "button", 21);
    i0.ɵɵtemplate(3, ModalComponent_ng_template_0_div_9_span_3_Template, 2, 1, "span", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.cancelButtonText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.confirmButtonText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.isValidFooterMessage(ctx_r7.footerMessage));
} }
function ModalComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4);
    i0.ɵɵtemplate(3, ModalComponent_ng_template_0_div_3_Template, 4, 3, "div", 5);
    i0.ɵɵtemplate(4, ModalComponent_ng_template_0_div_4_Template, 4, 2, "div", 6);
    i0.ɵɵelementStart(5, "div", 7);
    i0.ɵɵtemplate(6, ModalComponent_ng_template_0_ng_container_6_Template, 3, 1, "ng-container", 8);
    i0.ɵɵtemplate(7, ModalComponent_ng_template_0_ng_template_7_Template, 1, 0, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, ModalComponent_ng_template_0_div_9_Template, 4, 3, "div", 10);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const _r5 = i0.ɵɵreference(8);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r1.modalSize ? "modal-" + ctx_r1.modalSize : "")("cdkTrapFocusAutoCapture", true);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-label", !ctx_r1.showTitlebar && ctx_r1.titleText ? ctx_r1.titleText : null)("aria-labelledby", ctx_r1.showTitlebar ? ctx_r1.templateUUIDs.get("dialog-heading") : null)("aria-describedby", !ctx_r1.disableDescribedBy ? ctx_r1.templateUUIDs.get("dialog-content") : null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showTitlebar);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.description);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", ctx_r1.templateUUIDs.get("dialog-content"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.contentText)("ngIfElse", _r5);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.showFooter);
} }
const _c3 = ["*"];
const KEYCODES = {
    ESC_KEY: 27,
    TAB_KEY: 9,
};
export class ModalComponent {
    constructor(overlay, focusTrapFactory, doc) {
        this.overlay = overlay;
        this.focusTrapFactory = focusTrapFactory;
        this.focusOnConfirm = false;
        this.showTitlebar = true;
        this.showFooter = true;
        this.cancelButtonText = 'Cancel';
        this.confirmButtonText = 'Confirm';
        this.disableCancel = false;
        this.disableConfirm = false;
        this.disableClose = false;
        this.disableEscape = false;
        this.disableDescribedBy = false;
        this.panelClass = '';
        this.modalSize = null;
        this.btnCloseWhite = true; // default to true, OL modals currently have teal header (not from BS theme)
        this.close = new EventEmitter();
        this.confirm = new EventEmitter();
        this.cancel = new EventEmitter();
        this.open = new EventEmitter();
        this.overlayClick = new EventEmitter();
        this._destroy$ = new Subject();
        this.destroy$ = this._destroy$.asObservable();
        this.templateUUIDs = new TemplateUuids();
        this._doc = doc;
    }
    set isOpen(value) {
        if (value) {
            this.showModal();
        }
        else {
            this.hideModal();
        }
    }
    get isOpen() {
        return this._isOpen;
    }
    set description(value) {
        if (value instanceof TemplateRef) {
            this.descriptionTemplateRef = value;
        }
        if (typeof value === 'string') {
            this.descriptionText = value;
        }
        this._description = value;
    }
    get description() {
        return this._description;
    }
    keydownEvent(event) {
        this.keydown(event);
    }
    ngOnDestroy() {
        if (this.overlayRef) {
            this.overlayRef.dispose();
            this.focusTrap.destroy();
        }
        this._destroy$.next();
        this._destroy$.unsubscribe();
    }
    createModal() {
        let positionStrategy = this.overlay.position().global().centerHorizontally();
        if (this.marginTop) {
            positionStrategy = positionStrategy.top(this.marginTop);
        }
        this.overlayRef = this.overlay.create({
            positionStrategy,
            scrollStrategy: this.overlay.scrollStrategies.block(),
            hasBackdrop: true,
            backdropClass: 'mhe-overlay-dark-backdrop',
            panelClass: this.panelClass,
        });
    }
    showModal() {
        if (!this.overlayRef) {
            this.createModal();
        }
        if (this.modalTemplatePortal) {
            this.overlayRef.attach(this.modalTemplatePortal);
            // create a focus trap using the factory
            const modalEl = this.overlayRef.hostElement.querySelector('.modal-dialog');
            this.focusTrap = this.focusTrapFactory.create(modalEl);
        }
        fromEvent(this._doc, 'click')
            .pipe(tap((event) => {
            const modalContent = this.overlayRef && this.overlayRef.hostElement.querySelector('.modal-content');
            const internalClick = modalContent === null || modalContent === void 0 ? void 0 : modalContent.contains(event.target);
            if (!modalContent || internalClick === true || internalClick === undefined) {
                return;
            }
            this.onOverlayClick(event);
        }), subscribeOn(asyncScheduler), takeUntil(this.overlayRef.detachments()))
            .subscribe();
    }
    hideModal() {
        if (this.overlayRef && this.overlayRef.hasAttached()) {
            this.overlayRef.detach();
            this.focusTrap.destroy();
        }
        if (this.focusElementOnClose) {
            this.focusElementOnClose.nativeElement.focus();
        }
    }
    onCancel() {
        this.cancel.emit(this);
    }
    onConfirm() {
        this.confirm.emit(this);
    }
    onOverlayClick(event) {
        if (this.focusElementOnOverlayClick) {
            this.focusElementOnOverlayClick.nativeElement.focus();
        }
        this.overlayClick.emit(this);
    }
    onClose() {
        this.close.emit(this);
    }
    keydown(event) {
        if (event.keyCode === KEYCODES.ESC_KEY && !this.disableEscape) {
            this.onCancel();
        }
    }
    isValidFooterMessage(footerMessage) {
        return typeof footerMessage === 'string' && footerMessage.length > 0;
    }
    getModalDescriptionUUID() {
        return this.templateUUIDs.get(this._description ? 'dialog-description' : 'dialog-content');
    }
}
ModalComponent.ɵfac = function ModalComponent_Factory(t) { return new (t || ModalComponent)(i0.ɵɵdirectiveInject(i1.Overlay), i0.ɵɵdirectiveInject(i2.FocusTrapFactory), i0.ɵɵdirectiveInject(DOCUMENT)); };
ModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ModalComponent, selectors: [["mhe-modal"]], viewQuery: function ModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
        i0.ɵɵviewQuery(_c2, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cancelButton = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.confirmButton = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.modalTemplatePortal = _t.first);
    } }, hostBindings: function ModalComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("keydown", function ModalComponent_keydown_HostBindingHandler($event) { return ctx.keydownEvent($event); }, false, i0.ɵɵresolveDocument);
    } }, inputs: { isOpen: "isOpen", focusElementOnClose: "focusElementOnClose", focusElementOnOverlayClick: "focusElementOnOverlayClick", focusOnConfirm: "focusOnConfirm", showTitlebar: "showTitlebar", showFooter: "showFooter", contentText: "contentText", titleText: "titleText", cancelButtonText: "cancelButtonText", confirmButtonText: "confirmButtonText", disableCancel: "disableCancel", disableConfirm: "disableConfirm", disableClose: "disableClose", disableEscape: "disableEscape", disableDescribedBy: "disableDescribedBy", footerMessage: "footerMessage", panelClass: "panelClass", marginTop: "marginTop", modalSize: "modalSize", btnCloseWhite: "btnCloseWhite", description: "description" }, outputs: { close: "close", confirm: "confirm", cancel: "cancel", open: "open", overlayClick: "overlayClick" }, ngContentSelectors: _c3, decls: 2, vars: 0, consts: [["cdkPortal", ""], ["modalTemplatePortal", "cdkPortal"], [1, "modal", 2, "display", "block"], ["cdkTrapFocus", "", 1, "modal-dialog", 3, "ngClass", "cdkTrapFocusAutoCapture"], ["role", "dialog", "aria-modal", "true", 1, "modal-content"], ["class", "modal-header", 4, "ngIf"], ["class", "cdk-visually-hidden", 3, "id", 4, "ngIf"], [1, "modal-body", "scrollable-body", 3, "id"], [4, "ngIf", "ngIfElse"], ["modalBodyContent", ""], ["class", "modal-footer", 4, "ngIf"], [1, "modal-header"], [1, "modal-title", 3, "id"], ["type", "button", "class", "btn-close", "mheTooltip", "Close", "placement", "bottom", 3, "btn-close-white", "click", 4, "ngIf"], ["type", "button", "mheTooltip", "Close", "placement", "bottom", 1, "btn-close", 3, "click"], [1, "cdk-visually-hidden", 3, "id"], [3, "ngTemplateOutlet"], ["default", ""], [1, "modal-content-text"], [1, "modal-footer"], ["type", "button", "class", "action-button btn btn-secondary", "data-dismiss", "modal", 3, "disabled", "click", 4, "ngIf"], ["type", "button", "class", "action-button btn btn-primary", 3, "disabled", "click", 4, "ngIf"], ["class", "footer-msg", 4, "ngIf"], ["type", "button", "data-dismiss", "modal", 1, "action-button", "btn", "btn-secondary", 3, "disabled", "click"], ["cancelButton", ""], ["type", "button", 1, "action-button", "btn", "btn-primary", 3, "disabled", "click"], ["confirmButton", ""], [1, "footer-msg"]], template: function ModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, ModalComponent_ng_template_0_Template, 10, 11, "ng-template", 0, 1, i0.ɵɵtemplateRefExtractor);
    } }, dependencies: [i3.NgClass, i3.NgIf, i3.NgTemplateOutlet, i2.CdkTrapFocus, i4.CdkPortal, i5.TooltipDirective, i3.AsyncPipe, i6.TranslatePipe], styles: [".modal-container[_ngcontent-%COMP%]{position:fixed;top:0;left:0;right:0;bottom:0;z-index:999;overflow-y:auto}\n"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalComponent, [{
        type: Component,
        args: [{ selector: 'mhe-modal', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-template cdkPortal #modalTemplatePortal=\"cdkPortal\">\n  <div class=\"modal\" style=\"display: block\">\n    <div\n      cdkTrapFocus\n      class=\"modal-dialog\"\n      [ngClass]=\"modalSize ? 'modal-' + modalSize : ''\"\n      [cdkTrapFocusAutoCapture]=\"true\"\n    >\n      <div\n        class=\"modal-content\"\n        role=\"dialog\"\n        aria-modal=\"true\"\n        [attr.aria-label]=\"!showTitlebar && titleText ? titleText : null\"\n        [attr.aria-labelledby]=\"showTitlebar ? templateUUIDs.get('dialog-heading') : null\"\n        [attr.aria-describedby]=\"!disableDescribedBy ? templateUUIDs.get('dialog-content') : null\"\n      >\n        <div *ngIf=\"showTitlebar\" class=\"modal-header\">\n          <h2 [id]=\"templateUUIDs.get('dialog-heading')\" class=\"modal-title\">\n            {{ titleText }}\n          </h2>\n\n          <button\n            *ngIf=\"!disableClose\"\n            type=\"button\"\n            class=\"btn-close\"\n            [class.btn-close-white]=\"btnCloseWhite\"\n            [attr.aria-label]=\"'ngx-shared-close-dialog' | mheTranslate | async\"\n            (click)=\"onClose()\"\n            mheTooltip=\"Close\"\n            placement=\"bottom\"\n          ></button>\n        </div>\n\n        <div *ngIf=\"description\" [id]=\"templateUUIDs.get('dialog-description')\" class=\"cdk-visually-hidden\">\n          <ng-template [ngTemplateOutlet]=\"descriptionTemplateRef || default\"> </ng-template>\n          <ng-template #default>\n            <p>{{ descriptionText }}</p>\n          </ng-template>\n        </div>\n\n        <div [id]=\"templateUUIDs.get('dialog-content')\" class=\"modal-body scrollable-body\">\n          <ng-container *ngIf=\"contentText; else modalBodyContent\">\n            <p class=\"modal-content-text\">{{ contentText }}</p>\n          </ng-container>\n          <ng-template #modalBodyContent><ng-content></ng-content></ng-template>\n        </div>\n\n        <div *ngIf=\"showFooter\" class=\"modal-footer\">\n          <button\n            #cancelButton\n            *ngIf=\"cancelButtonText\"\n            type=\"button\"\n            class=\"action-button btn btn-secondary\"\n            [disabled]=\"disableCancel\"\n            (click)=\"onCancel()\"\n            data-dismiss=\"modal\"\n            [attr.cdkFocusInitial]=\"focusOnConfirm || showTitlebar ? null : ''\"\n          >\n            {{ cancelButtonText }}\n          </button>\n\n          <button\n            #confirmButton\n            *ngIf=\"confirmButtonText\"\n            type=\"button\"\n            class=\"action-button btn btn-primary\"\n            [disabled]=\"disableConfirm\"\n            (click)=\"onConfirm()\"\n            [attr.cdkFocusInitial]=\"focusOnConfirm && !showTitlebar ? '' : null\"\n          >\n            {{ confirmButtonText }}\n          </button>\n          <span *ngIf=\"isValidFooterMessage(footerMessage)\" class=\"footer-msg\">{{ footerMessage }}</span>\n        </div>\n      </div>\n    </div>\n  </div>\n</ng-template>\n", styles: [".modal-container{position:fixed;top:0;left:0;right:0;bottom:0;z-index:999;overflow-y:auto}/*# sourceMappingURL=modal.component.css.map */\n"] }]
    }], function () { return [{ type: i1.Overlay }, { type: i2.FocusTrapFactory }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { isOpen: [{
            type: Input,
            args: ['isOpen']
        }], focusElementOnClose: [{
            type: Input
        }], focusElementOnOverlayClick: [{
            type: Input
        }], focusOnConfirm: [{
            type: Input
        }], showTitlebar: [{
            type: Input
        }], showFooter: [{
            type: Input
        }], contentText: [{
            type: Input
        }], titleText: [{
            type: Input
        }], cancelButtonText: [{
            type: Input
        }], confirmButtonText: [{
            type: Input
        }], disableCancel: [{
            type: Input
        }], disableConfirm: [{
            type: Input
        }], disableClose: [{
            type: Input
        }], disableEscape: [{
            type: Input
        }], disableDescribedBy: [{
            type: Input
        }], footerMessage: [{
            type: Input
        }], panelClass: [{
            type: Input
        }], marginTop: [{
            type: Input
        }], modalSize: [{
            type: Input
        }], btnCloseWhite: [{
            type: Input
        }], description: [{
            type: Input,
            args: ['description']
        }], close: [{
            type: Output
        }], confirm: [{
            type: Output
        }], cancel: [{
            type: Output
        }], open: [{
            type: Output
        }], overlayClick: [{
            type: Output
        }], cancelButton: [{
            type: ViewChild,
            args: ['cancelButton']
        }], confirmButton: [{
            type: ViewChild,
            args: ['confirmButton']
        }], modalTemplatePortal: [{
            type: ViewChild,
            args: ['modalTemplatePortal', { static: true }]
        }], keydownEvent: [{
            type: HostListener,
            args: ['document:keydown', ['$event']]
        }] }); })();
